<div
  class="annotation-editor"
  [class.annotation-editor--fullscreen]="fullscreen"
  [style.--annotation-max-height]="maxDisplayHeight">
  <div
    #surface
    class="image-viewport"
    [class.image-viewport--empty]="!imageLoaded"
    (wheel)="onViewportWheel($event)">
    <div
      #imageLayer
      class="image-layer"
      *ngIf="imageLoaded"
      [style.width.px]="imageDisplayWidth"
      [style.height.px]="imageDisplayHeight"
      [style.transform]="imageViewTransform">
      <img [src]="imageElement?.src" alt="アノテーション対象画像" draggable="false">
      <canvas
        #annotationCanvas
        aria-label="画像アノテーション編集エリア"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerUp($event)">
      </canvas>
    </div>

    <div class="editor-message" *ngIf="loading"><ion-spinner name="crescent"></ion-spinner><span>画像を読み込んでいます</span></div>
    <div class="editor-message editor-message--error" *ngIf="errorMessage">{{ errorMessage }}</div>
    <div class="editor-message" *ngIf="!loading && !errorMessage && !imageLoaded">編集する画像を設定してください</div>

    <div
      #floatingPanel
      class="floating-options grouped-options pen-options"
      *ngIf="activePopover === 'pen'"
      [style.left.px]="floatingPanelPosition?.x"
      [style.top.px]="floatingPanelPosition?.y">
      <section>
        <button
          type="button"
          *ngFor="let mode of strokeModes"
          [class.selected]="selectedStrokeMode === mode.id"
          (click)="selectStrokeMode(mode.id)"><b>{{ mode.symbol }}</b><span>{{ mode.label }}</span></button>
      </section>
    </div>

    <div
      #floatingPanel
      class="floating-options color-options"
      *ngIf="activePopover === 'color'"
      [style.left.px]="floatingPanelPosition?.x"
      [style.top.px]="floatingPanelPosition?.y">
      <button
        type="button"
        *ngFor="let color of colors"
        class="color-choice"
        [class.selected]="selectedColor === color.value"
        [style.--choice-color]="color.value"
        [attr.aria-label]="color.label"
        (click)="selectColor(color.value)">
      </button>
    </div>

    <div
      #floatingPanel
      class="floating-options width-options"
      *ngIf="activePopover === 'width'"
      [style.left.px]="floatingPanelPosition?.x"
      [style.top.px]="floatingPanelPosition?.y">
      <button type="button" *ngFor="let width of widths" [class.selected]="selectedWidth === width.value" (click)="selectWidth(width.value)">
        <span [style.height.px]="Math.min(width.value, 14)"></span>{{ width.label }}
      </button>
    </div>

    <div
      #floatingPanel
      class="floating-options unit-options"
      *ngIf="activePopover === 'unit'"
      [style.left.px]="floatingPanelPosition?.x"
      [style.top.px]="floatingPanelPosition?.y">
      <section
        class="unit-group"
        *ngFor="let group of measurementUnitGroups"
        [attr.aria-label]="group.label">
        <button
          type="button"
          *ngFor="let unit of group.units"
          [class.selected]="selectedMeasurementUnit === unit.id"
          [attr.aria-label]="group.label + ' ' + unit.label"
          (click)="selectMeasurementUnit(unit.id)">{{ unit.label }}</button>
      </section>
    </div>

    <div
      #floatingPanel
      class="floating-options grouped-options marker-options"
      *ngIf="activePopover === 'marker'"
      [style.left.px]="floatingPanelPosition?.x"
      [style.top.px]="floatingPanelPosition?.y">
      <section>
        <button
          type="button"
          [class.selected]="selectedMarkerSet === 'number'"
          (click)="selectMarkerSet('number')"><b>①</b><span>数字</span></button>
        <button
          type="button"
          [class.selected]="selectedMarkerSet === 'alphabet'"
          (click)="selectMarkerSet('alphabet')"><b>A</b><span>英字</span></button>
        <button
          type="button"
          [class.selected]="selectedMarkerSet === 'text'"
          (click)="openTextMarkerInput()"><b>T</b><span>テキスト</span></button>
      </section>
    </div>

    <div
      #floatingPanel
      class="text-marker-panel"
      *ngIf="activePopover === 'text-marker'"
      [style.left.px]="floatingPanelPosition?.x"
      [style.top.px]="floatingPanelPosition?.y"
      (pointerdown)="$event.stopPropagation()">
      <label class="text-marker-label" for="text-marker-input">マーカーテキスト</label>
      <input
        id="text-marker-input"
        class="text-marker-input"
        type="text"
        placeholder="任意のテキストを入力"
        maxlength="60"
        enterkeyhint="done"
        [value]="textMarkerInput"
        (input)="onTextMarkerInput($event)"
        (blur)="confirmTextMarkerOnBlur()"
        (keydown.enter)="confirmTextMarkerFromKeyboard($event)">
      <ion-note>入力内容は写真へすぐ反映され、キーボードを閉じると保存されます。</ion-note>
      <div class="pad-actions text-marker-actions">
        <button
          type="button"
          (pointerdown)="prepareTextMarkerCancel()"
          (click)="cancelTextMarkerInput()">キャンセル</button>
      </div>
    </div>

    <div
      #floatingPanel
      class="measurement-pad"
      *ngIf="pendingMeasurementPoint"
      [style.left.px]="floatingPanelPosition?.x"
      [style.top.px]="floatingPanelPosition?.y"
      (pointerdown)="$event.stopPropagation()">
      <div class="measurement-display">{{ measurementInput || '0' }}{{ selectedMeasurementUnit }}</div>
      <div class="key-grid">
        <button type="button" *ngFor="let key of ['1','2','3','4','5','6','7','8','9','-','0','.']" (click)="appendMeasurementKey(key)">{{ key }}</button>
      </div>
      <div class="pad-actions">
        <button type="button" (click)="deleteMeasurementKey()">削除</button>
        <button type="button" (click)="cancelMeasurement()">キャンセル</button>
        <button type="button" class="confirm" [disabled]="!measurementInput" (click)="confirmMeasurement()">確定</button>
      </div>
    </div>

    <div
      #toolPalette
      class="tool-palette"
      [class.tool-palette--positioned]="palettePosition"
      [class.tool-palette--dragging]="paletteDragging"
      [style.left.px]="palettePosition?.x"
      [style.top.px]="palettePosition?.y"
      *ngIf="imageLoaded"
      (pointerdown)="$event.stopPropagation()">
      <button
        type="button"
        class="palette-drag-handle"
        aria-label="ツールパレットを移動"
        (pointerdown)="onPaletteDragStart($event)"
        (pointermove)="onPaletteDragMove($event)"
        (pointerup)="onPaletteDragEnd($event)"
        (pointercancel)="onPaletteDragEnd($event)">
        <b aria-hidden="true">⠿</b><span>移動</span>
      </button>
      <button type="button" [class.selected]="tool === 'pan'" (click)="selectTool('pan')" aria-label="写真を移動・拡大"><ion-icon name="move-outline"></ion-icon><span>表示</span></button>
      <button type="button" (click)="resetImageView()" aria-label="写真全体を表示"><ion-icon name="scan-outline"></ion-icon><span>全体</span></button>
      <button type="button" (click)="rotateImageClockwise()" aria-label="写真を右へ90度回転"><ion-icon name="refresh-outline"></ion-icon><span>回転</span></button>
      <button type="button" [class.selected]="tool === 'pen'" (click)="togglePopover('pen')" [attr.aria-label]="'ペンモード ' + selectedStrokeMode"><b>{{ strokeToolbarText }}</b><span>ペン</span></button>
      <button type="button" [class.selected]="tool === 'blur'" (click)="selectTool('blur')" aria-label="範囲をぼかす"><ion-icon name="eye-off-outline"></ion-icon><span>ぼかし</span></button>
      <button type="button" [class.selected]="tool === 'eraser'" (click)="selectTool('eraser')" aria-label="消しゴム"><ion-icon name="bandage-outline"></ion-icon><span>消去</span></button>
      <button type="button" [class.selected]="tool === 'measurement'" (click)="togglePopover('unit')" [attr.aria-label]="'測定単位 ' + selectedMeasurementUnit"><b>{{ selectedMeasurementUnit }}</b><span>測定</span></button>
      <button type="button" [class.selected]="tool === 'marker'" (click)="togglePopover('marker')" [attr.aria-label]="'マーカー ' + markerToolbarText"><b>{{ markerToolbarText }}</b><span>マーカー</span></button>
      <button type="button" (click)="togglePopover('color')" aria-label="色"><i class="current-color" [style.background]="selectedColor"></i><span>色</span></button>
      <button type="button" (click)="togglePopover('width')" aria-label="太さ"><i class="current-width" [style.height.px]="Math.min(selectedWidth, 12)"></i><span>太さ</span></button>
      <button type="button" [disabled]="!canUndo" (click)="undo()" aria-label="元に戻す"><ion-icon name="arrow-undo-outline"></ion-icon><span>Undo</span></button>
      <button type="button" [disabled]="!canRedo" (click)="redo()" aria-label="やり直す"><ion-icon name="arrow-redo-outline"></ion-icon><span>Redo</span></button>
    </div>
  </div>
</div>
